import { render, staticRenderFns } from "./checkboxTd.vue?vue&type=template&id=4f396ba1&scoped=true&"
import script from "./checkboxTd.vue?vue&type=script&lang=js&"
export * from "./checkboxTd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f396ba1",
  null
  
)

export default component.exports